import ModalContainer, { ModalContainerProps } from "components/common/ModalContainer";
import React from "react";
import { ForecastNewProductContentProps } from "./types/ForecastNewProductStepForm";
import Button from "components/common/Button";
import clsx from "clsx";
import ForecastNewProductPlanResultGraph from "./ForecastNewProductPlanResultGraph";
import ForecastNewProductPlanAddEdit from "./ForecastNewProductPlanAddEdit";
import Loader from "components/common/Loader";

type ForecastNewProductPlanEditProps = {} & ForecastNewProductContentProps &
    Omit<ModalContainerProps, "children">;

export default function ForecastNewProductPlanEdit(props: ForecastNewProductPlanEditProps) {
    const { stepper, formik, tailwindClassName, isLoading, ...rest } = props;

    return (
        <ModalContainer {...rest} tailwindClassName={clsx("max-w-[1356px]", tailwindClassName)}>
            <div>
                <div className="flex justify-between items-center px-[24px] py-[16px]">
                    <p className="text-[18px]  font-rocGroteskMedium">Edit product simulation </p>

                    <button onClick={rest.closeModal}>
                        <i className="ri-close-line"></i>
                    </button>
                </div>

                <hr className="border-[#E2E8F0]" />

                <div className="flex flex-col md:flex-row max-h-[calc(100vh-200px)] overflow-y-hidden">
                    <div className="w-full md:w-[50%] p-[24px] overflow-y-auto">
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <ForecastNewProductPlanAddEdit
                                isEdit
                                formik={formik}
                                stepper={stepper}
                            />
                        )}
                    </div>

                    <div className="border-t md:border-r border-[#F1F5F9]" />
                    <div className="w-full md:w-[50%] p-[24px] overflow-y-auto">
                        <ForecastNewProductPlanResultGraph stepper={stepper} formik={formik} />
                    </div>
                </div>

                <hr className="border-[#E2E8F0]" />

                <div className="flex gap-[8px] px-[24px] py-[12px]">
                    <div />

                    <div className="flex-1"></div>
                    <Button
                        btnText="Cancel"
                        onClick={rest.closeModal}
                        btnClassname="!bg-[#F4F5F7] cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                    <Button
                        btnText="Save Changes"
                        disabled={formik.isSubmitting || isLoading}
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                        btnClassname="cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                </div>
            </div>
        </ModalContainer>
    );
}
